/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-02-18 22:06:37
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-08-21 16:23:01
 * @FilePath: /intl-m-jdi-website-ssr/src/components/headerFooter/headerFooter.tsx
 * @Description: default
 */
'use client';
import FOOTER_PAGE_TYPE from '@/constants/footer';
import HEADER_PAGE_TYPE from '@/constants/header';
import React, { useEffect, useRef } from 'react';
import JDIFooter, { JDIFooterMethods } from './footer';
import JDIHeader from './header';
import styles from './headerFooterStyles.module.scss';
import { observer } from 'mobx-react';

interface Props {
  children: React.ReactNode;
  pageType: HEADER_PAGE_TYPE;
  footerPageType: FOOTER_PAGE_TYPE;
  disabled?: boolean;
}

export const HeaderFooter: React.FC<Props> = ({
  children,
  pageType,
  footerPageType,
  disabled = false,
}) => {
  const footerRef = useRef<JDIFooterMethods | null>(null);

  useEffect(() => {
    if (footerRef.current) {
      window.JDIfooter = footerRef.current;
    }
  }, []);

  return (
    <div className={`${styles.container} ${disabled ? styles.disabled : ''}`}>
      <div className={styles.header} id='main-header'>
        <JDIHeader pageType={pageType} disabled={disabled} />
      </div>
      <div id='main-container' className={styles.mainContainerStyles}>
        {children}
        {footerPageType !== FOOTER_PAGE_TYPE.HIDE && (
          <JDIFooter ref={footerRef} disabled={disabled} />
        )}
      </div>
    </div>
  );
};

export default observer(HeaderFooter);
